import { Transporter } from '../models/transporter.model';

export class ManifestService {
  static createTransporterManifest(transporter: Transporter): void {
    // getting web manifest from constants and modifying values
    const myDynamicManifest = {
      name: 'Bary',
      short_name: 'Bary',
      icons: [
        {
          src: window.location.origin + '/content/images/logo_bary_192.png',
          sizes: '192x192',
          type: 'image/png',
        },
        {
          src: window.location.origin + '/content/images/logo_bary_256.png',
          sizes: '256x256',
          type: 'image/png',
        },
        {
          src: window.location.origin + '/content/images/logo_bary_384.png',
          sizes: '384x384',
          type: 'image/png',
        },
        {
          src: window.location.origin + '/content/images/logo_bary_512.png',
          sizes: '512x512',
          type: 'image/png',
        },
      ],
      theme_color: '#000000',
      background_color: '#e0e0e0',
      start_url: window.location.origin,
      display: 'standalone',
      orientation: 'portrait',
    };

    // surcharge
    myDynamicManifest.name = transporter.shopName ?? 'Bary';
    myDynamicManifest.short_name = transporter.shopName ?? 'Bary';

    // appending modified manifest href value to index.html
    const stringManifest = JSON.stringify(myDynamicManifest);
    const blob = new Blob([stringManifest], { type: 'application/json' });
    const manifestURL = URL.createObjectURL(blob);
    document?.querySelector('#web-manifest')?.setAttribute('href', manifestURL);
  }
}
